/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useState } from "react";
import "./meeting-sdk.css";
import ZoomMtgEmbedded, { SuspensionViewType } from '@zoom/meetingsdk/embedded';
import MeetingSdkProps from "../../interfaces/meeting-sdk";
import debounce from "lodash.debounce";
import { toast } from "react-toastify";
import { createPopper, Modifier, ModifierArguments } from "@popperjs/core";

const chatCustomStyle: Modifier<"customStyle", {}> = {
  name: "customStyle",
  enabled: true,
  phase: "write",
  fn: ({ state }: ModifierArguments<{}>) => {
    state.elements.popper.classList.add("chat-style");
    const chatlement = state.elements.popper; // Access the popper element
    if (chatlement.getAttribute("aria-label") === "Chat") {
      const meetingSDK = document.getElementById("meetingSDKElement") as HTMLElement;
    const childElement = meetingSDK.querySelector('[aria-label="Zoom Web SDK Widget"]') as HTMLElement;
      if (childElement) {
        let height = childElement.clientHeight;
        const userAgent = navigator.userAgent.toLowerCase();
        const isEdge = userAgent.includes("edg/");
        if (isEdge) {
          if (window.innerWidth >= 1272 && window.innerWidth <= 1281) {
            height +=10;
          }
        }
        chatlement.style.position = "absolute"; // Ensure absolute positioning
        chatlement.style.left = "10px"; // Add an appropriate left positioning
        chatlement.style.inset = "unset"; // Reset inset property
        chatlement.style.transform = "none"; // Reset transform property
        chatlement.style.margin = "0px"; // Ensure no margins interfere
        chatlement.style.top = `${height + 180}px`; // Dynamically set top
        chatlement.style.marginLeft = `10px`; // Dynamically set top
        chatlement.style.left = `49.992%`; // Dynamically set top
      }
    }
  },
};

const chatModifiers = [chatCustomStyle];

const participantsCustomStyle: Modifier<"customStyle", {}> = {
  name: "customStyle",
  enabled: true,
  phase: "write",
  fn: ({ state }: ModifierArguments<{}>) => {
    state.elements.popper.classList.add("participants-style");
    const participantsElement = state.elements.popper; // Access the popper element
    if (participantsElement.getAttribute("aria-label") === "Participants") {
    const meetingSDK = document.getElementById("meetingSDKElement") as HTMLElement;
    const childElement = meetingSDK.querySelector('[aria-label="Zoom Web SDK Widget"]') as HTMLElement;
      if (childElement) {
        let height = childElement.clientHeight;
        const userAgent = navigator.userAgent.toLowerCase();
        const isEdge = userAgent.includes("edg/");
        if (isEdge) {
          if (window.innerWidth >= 1272 && window.innerWidth <= 1281) {
            height +=10;
          }
        }
        participantsElement.style.position = "absolute"; // Ensure absolute positioning
        participantsElement.style.left = "10px"; // Add an appropriate left positioning
        participantsElement.style.inset = "unset"; // Reset inset property
        participantsElement.style.transform = "none"; // Reset transform property
        participantsElement.style.margin = "0px"; // Ensure no margins interfere
        participantsElement.style.top = `${height + 60}px`; // Dynamically set top
        participantsElement.style.marginLeft = `10px`; // Dynamically set top
      }
    }
  },
};

const participantsModifiers = [participantsCustomStyle];

function applyCustomStylesToQA() {
  const qaElement = document.querySelector('[aria-label="Q&A"].zoom-MuiPopper-root.css-0') as HTMLElement;
  if (qaElement) {
    const meetingSDK = document.getElementById("meetingSDKElement") as HTMLElement;
    const childElement = meetingSDK.querySelector('[aria-label="Zoom Web SDK Widget"]') as HTMLElement;
    if (!childElement) {
      console.warn("Zoom Web SDK Widget not found.");
      return;
    }
    let height = childElement.clientHeight;
    // Create a dynamic <style> tag
    let dynamicStyle = document.getElementById("qa-dynamic-style");
    if (!dynamicStyle) {
      dynamicStyle = document.createElement("style");
      dynamicStyle.id = "qa-dynamic-style";
      document.head.appendChild(dynamicStyle);
    }
     // Detect macOS
    const userAgent = navigator.userAgent.toLowerCase();
    const isMac = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) || /(Macintosh|iOS)/i.test(navigator.userAgent);
    const isWindows11 = userAgent.includes("windows nt 10.0");
    const isFirefox = userAgent.includes("firefox");
    const isEdge = userAgent.includes("edg/");
  
    let leftOffset = (window.innerWidth / 4) * 3; // Default leftOffset
    if (isMac) {
      if (window.innerWidth >= 1024 && window.innerWidth <= 1279) {
        leftOffset += 10;
      } else if (window.innerWidth >= 1280 && window.innerWidth <= 1599) {
        leftOffset += 10;
      } else if (window.innerWidth >= 1600 && window.innerWidth <= 2559) {
        leftOffset += 8;
      }
    } else if(isWindows11 && isFirefox){
      if (window.innerWidth >= 1024 && window.innerWidth <= 1599) {
        leftOffset += 7;
      } 
    }
    // Apply special leftOffset for Edge at 1280px
    if (isEdge) {
      if (window.innerWidth >= 1272 && window.innerWidth <= 1281) {
       height +=10;
      }
    }
    // Inject CSS
    dynamicStyle.innerHTML = `
    .speaker-view [aria-label="Q&A"].zoom-MuiPopper-root.css-0 {
        position: absolute !important;
        inset: unset !important;
        transform: unset !important;
        top: ${height + 180}px !important;
        left: ${leftOffset}px !important;
      }
    `;
    console.log("Custom styles applied to Q&A element dynamically.");
  } else {
    console.warn("Q&A element not found.");
  }
}
function observeDOMChanges() {
  const observer = new MutationObserver(() => {
    const qaElement = document.querySelector('[aria-label="Q&A"].zoom-MuiPopper-root.css-0') as HTMLElement;
    if (qaElement) {
      applyCustomStylesToQA();
      observer.disconnect(); // Stop observing once the element is found
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
document.addEventListener("DOMContentLoaded", () => {
  observeDOMChanges();
});

interface VbImageInfoType {
  id: string;
  fileName: string;
  displayName: string;
  url: string;
}

const MeetingSdkView: React.FC<MeetingSdkProps> = ({
  meetingNumber,
  password,
  userName,
  userEmail,
  zakToken,
  tk,
  signature,
  setLoading,
  getVideoHeight ,
  virtualBg,
  isSlides,
  getHeightSdkMeeting,
  getWidthOfMeeting
}) => {
  const [bgArr, setBgArr] = useState<VbImageInfoType[]>([]);
  const [dimensions, setDimensions] = useState({
    width: Math.floor(window.innerWidth * 0.5) - 20, // Default 50% width
    height: 0, // Default height
  });

  // Effect to update bgArr when virtualBg prop changes
  useEffect(() => {
    if (virtualBg && Array.isArray(virtualBg)) {
      setBgArr(virtualBg);
    }
  }, [virtualBg]);

  // Separate effect to call addCustomBackground when bgArr updates
  useEffect(() => {
    if (bgArr.length > 0) {
      addCustomBackground(bgArr);
    }
  }, [bgArr]);

  const client = ZoomMtgEmbedded.createClient();
  const customButton = {
    text: "Update Virtual background",
    onClick: () => {
      updateVideoOptions();
    },
    className: "my-custom-button-class", // Optional: Add a custom CSS class
  };
  // Debounced version of openChat function
  const openChat = useCallback(
    debounce(async () => {
      const Participants = document.querySelector(
        '[aria-label="Participants"]'
      ) as HTMLElement;
      const Chatpanel = document.querySelector(
        '[aria-label="Chat Small Meeting6"]'
      ) as HTMLElement;

      const qnAPanel = document.querySelector(
        '[aria-label="QA Meeting6"]'
      ) as HTMLElement;

      if (Participants && Chatpanel) {

        Participants.click();
        Chatpanel.click();
        qnAPanel.click();
        setTimeout(async () => {
          await window.scrollTo({ top: 0 });
          setLoading(false);
        }, 0);

      } else {
        console.warn("One or more chat elements not found.");
      }
    }, 300),
    []
  ); // 300 ms debounce delay

  const updateZoomSize = useCallback(() => {
    let newWidth = Math.floor(window.innerWidth * 0.5) - 20;
    if (newWidth < 400) newWidth = 400; // Minimum width constraint
    setDimensions({ width: newWidth, height: 0 });
    client.updateVideoOptions({
      viewSizes: {
        default: { width: newWidth, height: 0 },
        ribbon: { width: 600, height: 400 },
      },
    });

    // Pass values to parent functions
     // Get dynamic height from SDK container
    setTimeout(()=>{
      const meetingSDKElement = document.getElementById("meetingSDKElement");
      const childElement = meetingSDKElement?.querySelector('[aria-label="Zoom Web SDK Widget"]') as HTMLElement;

      let newHeight = 0; // Default height
      if (childElement) {
        newHeight = childElement.clientHeight; // Get actual height from SDK
      }

      getWidthOfMeeting(newWidth);
      getHeightSdkMeeting(newHeight);
      applyCustomStylesToQA();
    },100);
  }, [client]);

  useEffect(() => {
    window.addEventListener("resize", updateZoomSize);
    return () => window.removeEventListener("resize", updateZoomSize);
  }, [updateZoomSize]);


  useEffect(() => {
    let isMounted = true;

    const startMeeting = async () => {
      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      const sdkKey = process.env.REACT_APP_SDK_KEY;
      const presenterLoginUrl = `${baseUrl}/login/presenter/${meetingNumber}`;

      let widthForVideo: any;
       // Calculate width as 50% of the screen width
      widthForVideo = Math.floor(window.innerWidth * 0.5) - 20; // Deduct 10px gap

      if (widthForVideo < 400) {
        // Minimum width constraint
        widthForVideo = 400;
      } else if (widthForVideo > window.innerWidth - 20) {
        // Ensure width does not exceed available space
        widthForVideo = window.innerWidth - 20;
      }


      try {
        const meetingSDKElement = document.getElementById("meetingSDKElement");
        const meetingSDKChatElement = document.getElementById(
          "meetingSDKChatElement"
        );
        const participantElement =
          document.getElementById("participantElement");

        if (!meetingSDKElement || !meetingSDKChatElement) {
          console.error("Meeting SDK elements not found.");
          return;
        }

        await client.init({
          zoomAppRoot: meetingSDKElement,
          language: "en-US",
          customize: {
            video: {
              isResizable: true,
              defaultViewType: 'gallery' as SuspensionViewType,
              popper: {
                disableDraggable: true,
              },
              viewSizes: {
                default: dimensions,
                ribbon: {
                  width: 600,
                  height: 400,
                },
              },
            },
            chat: {
              popper: {
                disableDraggable: true,
                anchorElement: meetingSDKChatElement,
                modifiers: chatModifiers,
              },
            },
            participants: {
              popper: {
                disableDraggable: true,
                placement: "right-start",
                anchorElement: participantElement,
                modifiers: participantsModifiers,
              },
            },
            toolbar: {
              buttons: [customButton],
            },
          },
        });

        if (isMounted) {
          await client
            .join({
              signature,
              sdkKey,
              meetingNumber,
              password,
              userName,
              userEmail,
              tk: tk || "",
              zak: zakToken || "",
            })
            .then(() => {
              document.body.classList.add("speaker-view");
              calculateHeight();
              openChat();
              const hideShareButton = document.querySelector('[aria-label="Share Screen"]');
              // if (isSlides) {
                (hideShareButton as HTMLElement).style.display =  'none';
              // }
              //Listen for meeting end event
              client.on("connection-change", (payload) => {
                if (payload.state === "Closed") {
                  window.location.href = presenterLoginUrl;
                }
              });
            }).catch((error) => {
              if (error.reason == "participant exist") {
                toast.error("You are already in the meeting on another device or tab.", {
                  onClose: () => {
                    window.location.reload();
                  }
                });
              } else {
                toast.error(`Error joining meeting: ${error.reason || error.message}`,
                  {
                    onClose: () => {
                      window.location.href = presenterLoginUrl;
                    },
                  }
                );
              }
            });
        }
      } catch (error) {
        setLoading(false);
        toast.error(`An error occurred while starting the meeting ${error}`);
      }
    };

    startMeeting();

    return () => {
      isMounted = false;
    };
  }, [
    meetingNumber,
    password,
    userName,
    userEmail,
    signature,
    tk,
    zakToken,
    openChat,
    setLoading
  ]);


  const calculateHeight = useCallback(() => {
    let sdkMeetingHeight;
    const parentElement = document.querySelector('.meeting-sdk-element');
    if (parentElement instanceof HTMLElement) {
      // const childElement = parentElement.querySelector('.MuiBox-root.css-12efcmn');
      const childElement = parentElement.querySelector('.react-draggable > div');
      if (childElement instanceof HTMLElement) {
        const childHeight = childElement.offsetHeight;
        sdkMeetingHeight = childHeight;
      } else {
        console.log('Child element with class "one child" not found.');
      }
    } else {
      console.log('Parent element with class "parent" not found.');
    }
    getVideoHeight(sdkMeetingHeight);

    const meetingSDK = document.getElementById("meetingSDKElement") as HTMLElement;
      const childElement = meetingSDK.querySelector( '[aria-label="Zoom Web SDK Widget"]') as HTMLElement;
    if (childElement) {
      const height = childElement.clientHeight;
      getHeightSdkMeeting(height);
      const width = childElement.clientWidth;
      getWidthOfMeeting(width);
    }
  }, []);

  const addCustomBackground = useCallback((virtualBg:  any[]) => {
    if (!client.isSupportVirtualBackground()) {
      console.warn(
        "Virtual backgrounds are not supported on this browser or device."
      );
      return;
    }
    if (!virtualBg || virtualBg.length === 0) {
      console.warn("No virtual backgrounds available to set.");
      return;
    }
    client
      ?.updateVirtualBackgroundList(virtualBg)
      .then(() => {
        const updatedVbStatus = client.getVirtualBackgroundStatus();
      })
      .catch((error) => {
        console.error("Error adding custom background:", error);
      });
  }, [client, virtualBg]);

  const updateVideoOptions = () => {
    client.updateVirtualBackgroundList([]).then(() => {
      toast.success("Virtual background list updated successfully!");
    }).catch((error) => {
      console.error("Error updating background list", error);
      toast.error("Failed to update the virtual background list.");
    });
  };

  return (
    <div className="meeting-sdk-container">
      <div id="meetingSDKElement" className="meeting-sdk-element"></div>
    </div>
  );
};

export default MeetingSdkView;
